import React from 'react';
import { Currency } from '../../interfaces/config';
import { Rate as RateEnum } from '../../enums';
import { getCurrencyById, mapRateTypeToString } from '../../utils';

import './styles.scss';

interface Props {
    className?: string;
    rateFrom: string;
    rateTo: string;
    currencyId: number;
    currencies: Currency[];
    rateType: RateEnum;
}

export const Rate = ({ className = '', rateFrom, rateTo, currencyId, currencies, rateType }: Props) => {
    return (
        <div className={`razem-app-rate ${className}`}>
            {`${rateFrom} ${rateTo && Number(rateTo) >= 0 ? `- ${rateTo}` : ''} ${
                getCurrencyById(currencies, currencyId)?.sign || ''
            }/${mapRateTypeToString(rateType)}`}
        </div>
    );
};
